import { CloudService } from "./CloudService/ClientLibsReference";
import * as ApiService from "./CloudService/ApiService";
import * as Format from "./FormatFunctions";
import * as log from "./Feedback/Log";

export class BaseViewModel {
  constructor() {
    this.codeTag = localStorage.getItem("codeTag");
    this.userId = localStorage.getItem("userId");
    this.logger = log;
  }

  //TODO tidy these methods up
  createException = async (exception, page, method) => {
    try {
      let exceptionRequest = {}; //new CloudService.ExceptionRequest();
      exceptionRequest.codeTag = this.codeTag;
      exceptionRequest.userId = this.userId;
      exceptionRequest.message = exception.message;
      exceptionRequest.platform = "PORTAL";
      exceptionRequest.page = page;
      exceptionRequest.method = method;
      exceptionRequest.deviceInformation = localStorage.deviceSettings;
      this.logger.info(exceptionRequest);
      let exceptionResponse = await ApiService.exceptionCreate(
        exceptionRequest
      );
      if (Format.isNotNull(exceptionResponse.errorCode)) {
        if (exceptionResponse.errorCode === 0) {
          return true;
        } else {
          return false;
        }
      }

      return false;
    } catch (error) {
      this.logger.error(error.message);
      return false;
    }
  };

  getStationListByCodeTag = async () => {
    let stationRequest = new CloudService.StationRequest();
    stationRequest.codeTag = this.codeTag;
    stationRequest.userId = this.userId;

    let stationResponse = await ApiService.stationGetByCodeTag(stationRequest);
    if (stationResponse.errorCode === 0) {
      if (Format.isNotNull(stationResponse.stationList)) {
        return stationResponse;
      } else {
        return stationResponse;
      }
    }

    return {};
  };

  getProductListByCodeTag = async () => {
    let productRequest = new CloudService.ProductRequest();
    productRequest.codeTag = this.codeTag;
    productRequest.userId = this.userId;
    let productResponse = await ApiService.productGetByCodeTag(productRequest);
    if (productResponse.errorCode === 0) {
      if (Format.isNotNull(productResponse.productList)) {
        return productResponse;
      } else {
        return productResponse;
      }
    }

    return {};
  };

  getPartListByCodeTag = async () => {
    let partRequest = new CloudService.PartRequest();
    partRequest.codeTag = this.codeTag;
    partRequest.userId = this.userId;
    let partResponse = await ApiService.partGetByCodeTag(partRequest);
    if (partResponse.errorCode === 0) {
      if (Format.isNotNull(partResponse.partList)) {
        return partResponse;
      } else {
        return partResponse;
      }
    }

    return {};
  };

  getWorkListByCodeTag = async () => {
    let request = new CloudService.WorkV2Request();
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    let response = await ApiService.workGetByCodeTag(request);
    if (response.errorCode === 0) {
      if (Format.isNotNull(response.workList)) {
        return response;
      } else {
        return response;
      }
    }

    return {};
  };

  getWorkItemListByWorkId = async id => {
    let request = new CloudService.WorkItemV2Request();
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    request.workId = id;
    let response = await ApiService.workItemGetByWorkId(request);
    if (response.errorCode === 0) {
      if (Format.isNotNull(response.workItemList)) {
        return response;
      } else {
        return response;
      }
    }

    return {};
  };

  getAttributeListByCodeTag = async () => {
    let request = new CloudService.AttributeRequest();
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    let response = await ApiService.attributeGetByCodeTag(request);
    if (response.errorCode === 0) {
      if (Format.isNotNull(response.attributeList)) {
        return response;
      } else {
        return response;
      }
    }

    return {};
  };

  getAttributeSetListByCodeTag = async () => {
    let request = new CloudService.AttributeSetRequest();
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    let response = await ApiService.attributeSetGetByCodeTag(request);
    if (response.errorCode === 0) {
      if (Format.isNotNull(response.attributeSetList)) {
        return response;
      } else {
        return response;
      }
    }

    return {};
  };

  getOrderListByCodeTag = async () => {
    let orderRequest = new CloudService.OrderV2Request();
    orderRequest.codeTag = this.codeTag;
    orderRequest.userId = this.userId;
    let orderResponse = await ApiService.orderGetByCodeTag(orderRequest);
    if (orderResponse.errorCode === 0) {
      if (Format.isNotNull(orderResponse.orderList)) {
        return orderResponse;
      } else {
        return orderResponse;
      }
    }

    return {};
  };

  getDeliveryListByCodeTag = async () => {
    let deliveryRequest = new CloudService.DeliveryV2Request();
    deliveryRequest.codeTag = this.codeTag;
    deliveryRequest.userId = this.userId;
    let deliveryResponse = await ApiService.deliveryGetByCodeTag(
      deliveryRequest
    );
    if (deliveryResponse.errorCode === 0) {
      if (Format.isNotNull(deliveryResponse.deliveryList)) {
        return deliveryResponse;
      } else {
        return deliveryResponse;
      }
    }

    return {};
  };

  getSiteListByCodeTag = async () => {
    let siteRequest = new CloudService.SiteV2Request();
    siteRequest.codeTag = this.codeTag;
    siteRequest.userId = this.userId;
    let siteResponse = await ApiService.siteGetByCodeTag(siteRequest);
    if (siteResponse.errorCode === 0) {
      if (Format.isNotNull(siteResponse.siteList)) {
        return siteResponse;
      } else {
        return siteResponse;
      }
    }

    return {};
  };

  getSiteListByClientId = async clientId => {
    let siteRequest = new CloudService.SiteV2Request();
    siteRequest.codeTag = this.codeTag;
    siteRequest.userId = this.userId;
    siteRequest.clientId = clientId;
    let siteResponse = await ApiService.siteGetByClientId(siteRequest);
    if (siteResponse.errorCode === 0) {
      if (Format.isNotNull(siteResponse.siteList)) {
        return siteResponse;
      } else {
        return siteResponse;
      }
    }

    return {};
  };

  getCatalogueListByCodeTag = async () => {
    let catalogueRequest = new CloudService.CatalogueRequest();
    catalogueRequest.codeTag = this.codeTag;
    catalogueRequest.userId = this.userId;
    let catalogueResponse = await ApiService.catalogueGetByCodeTag(
      catalogueRequest
    );
    if (catalogueResponse.errorCode === 0) {
      if (Format.isNotNull(catalogueResponse.catalogueList)) {
        return catalogueResponse;
      } else {
        return catalogueResponse;
      }
    }

    return {};
  };

  getCategoryListByCatalogueId = async catalogueId => {
    let categoryRequest = new CloudService.CategoryRequest();
    categoryRequest.codeTag = this.codeTag;
    categoryRequest.userId = this.userId;
    categoryRequest.catalogueId = catalogueId;
    let categoryResponse = await ApiService.categoryGetByCatalogueId(
      categoryRequest
    );
    if (categoryResponse.errorCode === 0) {
      if (Format.isNotNull(categoryResponse.categoryList)) {
        return categoryResponse;
      } else {
        return categoryResponse;
      }
    }

    return {};
  };

  getBuildingListBySiteId = async catalogueId => {
    let buildingRequest = new CloudService.BuildingV2Request();
    buildingRequest.codeTag = this.codeTag;
    buildingRequest.userId = this.userId;
    buildingRequest.siteId = catalogueId;
    let buildingResponse = await ApiService.buildingGetBySiteId(
      buildingRequest
    );
    if (buildingResponse.errorCode === 0) {
      if (Format.isNotNull(buildingResponse.buildingList)) {
        return buildingResponse;
      } else {
        return buildingResponse;
      }
    }

    return {};
  };

  getLocationListByBuildingId = async buildingId => {
    let locationRequest = new CloudService.LocationV2Request();
    locationRequest.codeTag = this.codeTag;
    locationRequest.userId = this.userId;
    locationRequest.buildingId = buildingId;
    let locationResponse = await ApiService.locationGetByBuildingId(
      locationRequest
    );
    if (locationResponse.errorCode === 0) {
      if (Format.isNotNull(locationResponse.locationList)) {
        return locationResponse;
      } else {
        return locationResponse;
      }
    }

    return {};
  };

  getUserListByCodeTag = async () => {
    let userRequest = new CloudService.UserRequest();
    userRequest.codeTag = localStorage.getItem("codeTag");
    userRequest.userId = localStorage.getItem("userId");

    let userResponse = await ApiService.userListInBusiness(userRequest);

    if (userResponse.errorCode === 0) {
      if (Format.isNotNull(userResponse.users)) {
        return userResponse;
      } else {
        return userResponse;
      }
    }

    return {};
  };

  getSupplierListByCodeTag = async () => {
    let businessRequest = new CloudService.BusinessRequest();
    businessRequest.codeTag = localStorage.getItem("codeTag");
    businessRequest.userId = localStorage.getItem("userId");
    businessRequest.type = "Supplier";

    let businessResponse = await ApiService.businessListByType(businessRequest);

    if (businessResponse.errorCode === 0) {
      if (Format.isNotNull(businessResponse.businesses)) {
        return businessResponse;
      } else {
        return businessResponse;
      }
    }

    return {};
  };

  getCustomerListByCodeTag = async () => {
    let businessRequest = new CloudService.BusinessRequest();
    businessRequest.codeTag = localStorage.getItem("codeTag");
    businessRequest.userId = localStorage.getItem("userId");
    businessRequest.type = "Client";

    let businessResponse = await ApiService.businessListByType(businessRequest);

    if (businessResponse.errorCode === 0) {
      if (Format.isNotNull(businessResponse.businesses)) {
        return businessResponse;
      } else {
        return businessResponse;
      }
    }

    return {};
  };

  getInvoiceListByCodeTag = async () => {
    let invoiceRequest = new CloudService.InvoiceV2Request();
    invoiceRequest.codeTag = localStorage.getItem("codeTag");
    invoiceRequest.userId = localStorage.getItem("userId");

    let invoiceResponse = await ApiService.invoiceGetByCodeTag(invoiceRequest);

    if (invoiceResponse.errorCode === 0) {
      if (Format.isNotNull(invoiceResponse.businesses)) {
        return invoiceResponse;
      } else {
        return invoiceResponse;
      }
    }

    return {};
  };
}



// WEBPACK FOOTER //
// ./src/common/BaseViewModel.js